module.exports = __webpack_public_path__ + "static/media/Multi-platform.b37dba5b.png";